<template>
    <div id="landing-banner">
        <!--=====================================-->
        <!--=        Banner Area Start          =-->
        <!--=====================================-->
        <section class="banner banner-style-2 mb--80">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-sm-12 col-md-7 col-lg-9">
                        <div class="banner-content" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">
                            <p class="letter-spacing-1 font-weight-100 primary bold h4 mb-2">Planes de inversión automática.</p>
                            <h1 class="letter-spacing-1 title mb-3">¡Siéntate y relájate!</h1>
                            <h4 class="letter-spacing-1 white font-weight-100">Configura tu plan de inversión a la medida
                                y maximiza el valor de tu cuenta con el mínimo esfuerzo.</h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "LandingBanner",
    components: {
        
    }
}

</script>

<style scoped>
.banner-style-2 {
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/fotografias/investors/foto-investment-plans.png") !important;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 145px 0 145px 200px;
    background-position-x: center;
}

@media only screen and (min-width: 1200px) and (max-width: 1599px) {
    .banner-style-2 {
        padding: 145px 30px 60px 40px;
    }
}

@media only screen and (max-width: 575px) {
    .banner.banner-style-2 {
        padding: 80px 30px;
    }
}

.banner.banner-style-5::after {
    background-color: transparent;
}

.banner {
    min-height: 550px;
}

.align-self-center {
    align-self: center;
}

.letter-spacing-1  {
    letter-spacing: 1px;
}

</style>